import React from 'react'
import {
  AppBar,
  Avatar,
  IconButton,
  Toolbar,
  Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Menu } from '@material-ui/icons'

const useStyle = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  avatar: {
    marginRight: theme.spacing(1)
  }
}))

type Props = {
  openDrawer: () => void
}

const AppToolbar: React.VFC<Props> = ({ openDrawer }) => {
  const classes = useStyle()

  return (
    <AppBar position="sticky">
      <Toolbar>
        <IconButton
          edge="start"
          className={classes.menuButton}
          color="inherit"
          aria-label="menu"
          onClick={openDrawer}
        >
          <Menu />
        </IconButton>
        <Avatar
          src="https://pbs.twimg.com/profile_images/1283657522700627968/_0fjFMo__400x400.png"
          className={classes.avatar}
        />
        <Typography variant="h6">まとめ保管庫びゅーわー</Typography>
      </Toolbar>
    </AppBar>
  )
}

export default AppToolbar
